export const dashBoardConstants = {
    //request
	REQUEST_DASH_BOARD_DATA: 'REQUEST_DASH_BOARD_DATA',
    RECIEVE_DASH_BOARD_DATA: 'RECIEVE_DASH_BOARD_DATA',
    ERROR_DASH_BOARD_DATA: 'ERROR_DASH_BOARD_DATA',

    //AssessorGroupList
    REQUEST_ASSESSOR_GROUP_LIST: 'REQUEST_ASSESSOR_GROUP_LIST',
    RECIEVE_ASSESSOR_GROUP_LIST: 'RECIEVE_ASSESSOR_GROUP_LIST',
    ERROR_ASSESSOR_GROUP_LIST: 'ERROR_ASSESSOR_GROUP_LIST',

    REQUEST_INVITE_POST: 'REQUEST_INVITE_POST',
    RECIEVE_INVITE_POST: 'RECIEVE_INVITE_POST',
    ERROR_INVITE_POST: 'ERROR_INVITE_POST',

    REQUEST_REMOVE_ASSESSMENT: 'REQUEST_REMOVE_ASSESSMENT',
    RECIEVE_REMOVE_ASSESSMENT: 'RECIEVE_REMOVE_ASSESSMENT',
    ERROR_REMOVE_ASSESSMENT: 'ERROR_REMOVE_ASSESSMENT',

    REQUEST_EDTI_ASSESSMENT: 'REQUEST_EDTI_ASSESSMENT',
    RECIEVE_EDTI_ASSESSMENT: 'RECIEVE_EDTI_ASSESSMENT',
    ERROR_EDTI_ASSESSMENT: 'ERROR_EDTI_ASSESSMENT',

    REQUEST_SEND_REMAINDER_INDIVIDUAL: 'REQUEST_SEND_REMAINDER_INDIVIDUAL',
    RECIEVE_SEND_REMAINDER_INDIVIDUAL: 'RECIEVE_SEND_REMAINDER_INDIVIDUAL',
    ERROR_SEND_REMAINDER_INDIVIDUAL: 'ERROR_SEND_REMAINDER_INDIVIDUAL',

    REQUEST_SEND_REMAINDER_BULK: 'REQUEST_SEND_REMAINDER_BULK',
    RECIEVE_SEND_REMAINDER_BULK: 'RECIEVE_SEND_REMAINDER_BULK',
    ERROR_SEND_REMAINDER_BULK: 'ERROR_SEND_REMAINDER_BULK',

    REQUEST_FINAL_ASSESSMENTS: 'REQUEST_FINAL_ASSESSMENTS',
    RECIEVE_FINAL_ASSESSMENTS: 'RECIEVE_FINAL_ASSESSMENTS',
    ERROR_FINAL_ASSESSMENTS: 'ERROR_FINAL_ASSESSMENTS',

    REQUEST_PDF: 'REQUEST_PDF',
    RECIEVE_PDF: 'RECIEVE_PDF',
    ERROR_PDF: 'ERROR_PDF',
    
}


// WEBPACK FOOTER //
// ./src/_constants/dashBoard.constants.js